import React from 'react';
import { Routes, Route, Link, useLocation } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ProtectedRoute from './components/ProtectedRoute';
import Home from './pages/Home';
import About from './pages/About';
import Features from './pages/Features';
import Contact from './pages/Contact';
import Profile from './pages/Profile';
import Login from './pages/Login';
import PersonalityTest from './pages/PersonalityTest';
import DiScTest from './pages/DiScTest';
import IkigaiAssessment from './pages/IkigaiAssessment';
import Dashboard from './pages/Dashboard';
import Register from './pages/Register';
import Forgotpassword from './pages/ForgotPassword';
import OTP from './pages/OTP';
import ResetPassword from './pages/ResetPassword';
import Analysis from './pages/Analysis';
import FAQ from './pages/FAQ';
import IkigaiApp from './pages/IkigaiApp';
import BigFiveTest from './pages/BigFiveTest';
import ViaCharacterStrengthTest from './pages/ViaCharacterStrengthTest';
import EmotionalIntelligenceTest from './pages/EmotionalIntelligenceTest';
import HighStrengthTest from './pages/HighStrengthTest';
import CompetencyQuiz from './pages/CompetencyQuiz';
import PersonalityTestLanding from './pages/PersonalityTestLanding';
import LearningStyleAssessment from './pages/LearningStyleAssessment';
import EnneagramTest from './pages/EnneagramTest';
import MbtiTest from './pages/MbtiTest';
import SevenQuestion from './pages/SevenQuestion';
import TestResultsDashboard from './components/TestResultsDashboard';
import JohariFeedback from './pages/JohariFeedback';
import NotFound from './components/NotFound';
import AdminUserManagement from './pages/AdminUserManagement';
import TestsManagement from './pages/TestsManagement';
import TestReportAdmin from './pages/TestReportAdmin';
import AdminCommunication from './pages/AdminCommunication';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import CookiePolicy from './pages/CookiePolicy';
import Disclaimer from './pages/Disclaimer';
import DataProtection from './pages/DataProtection';
import { useAuth } from './context/AuthContext';
import UserProfileMini from './pages/UserProfileMini';
import EssenceEcho from './pages/EssenceEcho';

function App() {  
  const location = useLocation();
  const hideNavbar = location.pathname === '/login';
  const { user } = useAuth?.() || {};
  
  return (
    <div className="min-h-screen bg-gray-50">
      <main className="bg-gradient-to-r from-white via-[#EFF6FF] to-[#F9FAFB] min-h-screen">
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/features" element={<Features />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/faq" element={<FAQ />} />
          {/* <Route path="/" element={<EssenceEcho />} /> */}
          {/* <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgotpassword" element={<Forgotpassword />} />
          <Route path="/otp" element={<OTP />} />
          <Route path="/resetPassword" element={<ResetPassword />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />
          <Route path="/disclaimer" element={<Disclaimer />} />
          <Route path="/data-protection" element={<DataProtection />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/feedback/:userId" element={<JohariFeedback />} />
          <Route path="/personalitytestlanding" element={<PersonalityTestLanding />} /> */}
          
          {/* Protected Routes - Require Authentication */}
          {/* <Route path="/profile" element={
            <ProtectedRoute>
              <Profile />
            </ProtectedRoute>
          } />
          <Route path="/dashboard" element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          } />
          <Route path="/admin/users" element={
            <ProtectedRoute>
              {user?.role === 'admin' ? <AdminUserManagement /> : <NotFound />}
            </ProtectedRoute>
          } />
          <Route path="/admin/tests" element={
            <ProtectedRoute>
              {user?.role === 'admin' ? <TestsManagement /> : <NotFound />}
            </ProtectedRoute>
          } />
          <Route path="/admin/tests/:id" element={
            <ProtectedRoute>
              {user?.role === 'admin' ? <TestReportAdmin /> : <NotFound />}
            </ProtectedRoute>
          } />
          <Route path="/admin/communication" element={
            <ProtectedRoute>
              {user?.role === 'admin' ? <AdminCommunication /> : <NotFound />}
            </ProtectedRoute>
          } />
          <Route path="/analysis" element={
            <ProtectedRoute>
              <Analysis />
            </ProtectedRoute>
          } />
          <Route path="/test-results" element={
            <ProtectedRoute>
              <TestResultsDashboard />
            </ProtectedRoute>
          } />
          <Route path="/me" element={
            <ProtectedRoute>
              <UserProfileMini />
            </ProtectedRoute>
          } />
          
          <Route path="/personality-test" element={
            <ProtectedRoute>
              <PersonalityTest />
            </ProtectedRoute>
          } />
          <Route path="/disctest" element={
            <ProtectedRoute>
              <DiScTest />
            </ProtectedRoute>
          } />
          <Route path="/ikigaiassessment" element={
            <ProtectedRoute>
              <IkigaiAssessment />
            </ProtectedRoute>
          } />
          <Route path="/ikigaiapp" element={
            <ProtectedRoute>
              <IkigaiApp />
            </ProtectedRoute>
          } />
          <Route path="/bigfivetest" element={
            <ProtectedRoute>
              <BigFiveTest />
            </ProtectedRoute>
          } />
          <Route path="/viacharacterstrengthtest" element={
            <ProtectedRoute>
              <ViaCharacterStrengthTest />
            </ProtectedRoute>
          } />
          <Route path="/emotionalintelligencetest" element={
            <ProtectedRoute>
              <EmotionalIntelligenceTest />
            </ProtectedRoute>
          } />
          <Route path="/highstrengthtest" element={
            <ProtectedRoute>
              <HighStrengthTest />
            </ProtectedRoute>
          } />
          <Route path="/competencyquiz" element={
            <ProtectedRoute>
              <CompetencyQuiz />
            </ProtectedRoute>
          } />
          <Route path="/learningstyleassessment" element={
            <ProtectedRoute>
              <LearningStyleAssessment />
            </ProtectedRoute>
          } />
          <Route path="/enneagramtest" element={
            <ProtectedRoute>
              <EnneagramTest />
            </ProtectedRoute>
          } />
          <Route path="/mbtitest" element={
            <ProtectedRoute>
              <MbtiTest />
            </ProtectedRoute>
          } />
          <Route path="/sevenquestion" element={
            <ProtectedRoute>
              <SevenQuestion />
            </ProtectedRoute>
          } />
          <Route path="/essence-echo" element={<EssenceEcho />} />
          
          <Route path="*" element={<NotFound />} /> */}
        </Routes>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
      </main>
    </div>
  );
}

export default App;
